import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Stromerzeugungsanlagen extends BaseModel {
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;
    kanton_id: number | null = null;
    jahr: number | null = null;
    quelle: string | null = null;
    referenz: string | null = null;
    strassenname: string | null = null;
    hausnummer: string | null = null;
    plz: string | null = null;
    ort: string | null = null;
    egid: number | null = null;
    bfs_gemeindenummer: number | null = null;
    nutzungsart_id: number | null = null;
    bauperiode: number | null = null;
    name: string | null = null;
    realisierte_leistung_erstinbetriebnahme: number | null = null;
    realisierte_leistung_inkl_erweiterungen: number | null = null;
    speicherkraftwerk: boolean | null = null;
    geplantes_datum_inbetriebnahme: Dayjs | null = null;
    datum_inbetriebnahme: Dayjs | null = null;
    jahresproduktion: number | null = null;
    technologie_code: string | null = null;
    support_schema: string | null = null;
    periodizitaet: number | null = null;
    anlagenstatus_kev: string | null = null;
    betriebsstatus: string | null = null;
    hkn: string | null = null;
    technologie_stromerzeugung_id: number | null = null;
    technologie_stromerzeugung: string | null = null;
    leistung: number | null = null;
    produktion: number | null = null;
    produktiv: boolean | null = null;
    ganzes_jahr_in_betrieb: boolean | null = null;
    anzahl_monate_in_betrieb: number | null = null;
    nutzungsart: string | null = null;
    kanton: string | null = null;
    kanton_kuerzel: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
            geplantes_datum_inbetriebnahme: (val) => dayjs(val),
            datum_inbetriebnahme: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Stromerzeugungsanlagen';
    }
}

export async function createNewStromerzeugungsanlagen(): Promise<Stromerzeugungsanlagen> {
    const model = createModel(Stromerzeugungsanlagen, {});
    await model.save();
    return model;
}

export class StromerzeugungsanlagenCollection extends BaseCollection<Stromerzeugungsanlagen> {
    protected modelCls = Stromerzeugungsanlagen;

    public getModelClassName(): string {
        return 'Stromerzeugungsanlagen';
    }
}